// Join a list of items into a gramatical english sentence. (e.g. one, two, and three).
export function joinSentence(parts: string[], endSeperator = 'and') {
  if (parts.length < 2) return parts.join('');

  const [lastPart, ...initialParts] = [...parts].reverse();
  return initialParts.reverse().join(', ') + ` ${endSeperator} ` + lastPart;
}
